module.exports = (__webpack_require__(6))(452);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react-dom/index.js from dll-reference vendor_aa0bb54e7e791c5951ff
// module id = 12
// module chunks = 0 1 2 3 4 5 6 7